import React, { useCallback, useEffect, useMemo } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { IoChevronBack } from 'react-icons/io5';

import { getPathologyAction, getCentersAction } from '../../actions/contentActions';
import TypeView from '../../components/Pathologies/TypeView/TypeView';
import styles from './PathologyView.module.scss';

export default function PathologyView() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const pathology = useSelector((state) => state.content.pathology);
  const centersList = useSelector((state) => state.content.centers) || [];

  const load = useCallback(() => {
    if (!id) return;
    getPathologyAction(dispatch, id);
    getCentersAction(dispatch);
  }, [dispatch, id]);

  useEffect(() => {
    load();
  }, [load]);

  const centers = useMemo(() => centersList.filter((c) => {
    const found = c.services?.some(
      (s) => s.pathologies?.some((p) => p.pathology === pathology?._id),
    );
    return found;
  }), [centersList, pathology?._id]);

  return (
    <div className={styles.container}>
      <header>
        <div className={styles.title}>
          <h2>{pathology?.name || 'Pathologie'}</h2>
          <Link to="/majee/pathologies" className={styles.back}>
            <IoChevronBack size={18} />
            Retour à la liste
          </Link>
        </div>
      </header>

      {pathology?._id && (
        <main className={styles.content}>
          <div className={styles.col}>
            <div className={styles.infos}>
              <div className={styles.name}>
                <div
                  className={styles.icon}
                  style={{ backgroundColor: pathology?.color || '#CFD0DB' }}
                />
                <h1>{pathology?.name}</h1>
              </div>
              <p>
                <label>Catégorie</label>
                <br />
                {pathology?.category || '—'}
              </p>
            </div>
            {pathology?.types?.map((t) => (
              <TypeView key={t._id || t.name} type={t} />
            ))}
          </div>

          <div className={`${styles.col} ${styles.right}`}>
            <div className={styles.infos}>
              <h3>Centres</h3>
              <div className={styles.centers}>
                {centers.map((c) => (
                  <Link
                    key={c._id}
                    className={styles.item}
                    to={`/majee/centres/${c._id}`}
                  >
                    {c.name}
                    {c?.location?.city ? ` - ${c.location.city}` : ''}
                  </Link>
                ))}
                {!centers.length && <p>—</p>}
              </div>
            </div>
          </div>
        </main>
      )}
    </div>
  );
}
